export default "__VITE_ASSET__CmZiu2FI__"